<template>
  <el-dialog :visible.sync="show" width="30%" :before-close="closeDialog" :close-on-click-modal="false">
    <el-form>

      <el-form-item label="密码:" label-width='120px'>
        <el-input v-model="submit_data.password" :placeholder="submit_rules.password.placeholder" style="width: 80%;">
        </el-input>
      </el-form-item>

    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="onSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  var _this;
  export default {
    props: {
      'isShow': Boolean,
      'data': ''
    },
    watch: {

      isShow(newData, oldData) {

        _this.show = true;
        _this.submit_data.driver_code = _this.data;

      },
    },
    data() {
      return {


        show: false,

        // 表单数据
        submit_data: {
          driver_code: '',
          password: ''
        },

        submit_rules: {
          driver_code: {
            placeholder: '公司名称100字以内',
            rules: {
              required: true,
              message: '角色名100个汉字以下',
              regulation: 'special',
              rulesData: 'driver_code'
            }
          },
          password: {
            placeholder: '请输入密码',
            rules: {
              required: true,
              message: '密码6-20位',
              regulation: 'between_str',
              rulesData: [6, 20]
            }
          }
        },

      };
    },
    created() {

      _this = this;

    },
    methods: {


      // 关闭方法
      closeDialog() {
        _this.show = false;
        for (const key in _this.submit_data) {
          _this.submit_data[key] = '';
        }
      },
      // 提交
      onSubmit() {
        _this.$post(
            "/driver/editDriverSubmit",
            _this.submit_data,
            _this.submit_rules
          )
          .then(res => {

            // 触发父组件自定义事件刷新表格
            _this.$emit('onSubmit');
            _this.closeDialog();

            _this.$message.success({
						message: res.msg,
						duration:1500
					});
          }).catch(res => {

          })
      },

    }
  };
</script>

<style scoped>
  .form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }

  .avatar-uploader {
    width: 100px;
    height: 100px;
  }
</style>